import { Reinforcement } from '../elements/reinforcement';
import { SideProfileActive } from '../elements/side-profile-active';
import { SideColorsLegacy, Wood } from '@icc/construction-elements/types';
import { IccProfileSideColors } from '@icc/construction-elements/types';
import { Profile } from './profile';

/** Łączniki */
export class CouplingActive extends SideProfileActive {
    /** Czy ustawiony domyślnie */
    isDefault = true;
    /** Orientacja */
    direction: 'horizontal' | 'vertical' = 'vertical';
    /**
     * Identyfikatory sąsiadujących ram oraz indeksy krawędzi ram z prawej lub dołu,
     * do których jest przykręcony boczny profil
     */
    otherFramesId: {
        id: number;
        edges: number[];
        positionId?: string;
    }[] = [];
    /** Identyfiatory łączników prostopadłych */
    perpendicularCouplings: {
        top?: number[];
        bottom?: number[];
        left?: number[];
        right?: number[];
    } = {};
    /** Typ */
    type = '';
    /** Kąt rozwarcia łącznika */
    angle = 0;

    otherSide: 'left' | 'right' | 'top' | 'bottom' | 'left-top' | 'right-top' = 'bottom';
    profile?: Profile;
    /** Zewnętrzna szerokość łącznika (alias dla widthOut, używany przez setCouplingProfile) */
    outerWidth?: number;
    /** Wybrana szerokość (dla profili ze zmienną szerokością) */
    selectedWidth?: number;

    constructor(params?: {
        id: number;
        profileId: number;
        profileCategoryId?: number;
        length: number;
        direction: 'horizontal' | 'vertical';
        width: number;
        widthOut: number;
        savedWidth?: number;
        color: IccProfileSideColors;
        wood: Wood;
        reinforcement: Reinforcement;
        adjacentSideProfileId: number[];
        adjacentOtherSideProfileId: number[];
        adjacentCouplingId?: number[];
        framesId: {
            id: number;
            edges: number[];
            positionId?: string;
        }[];
        otherFramesId: {
            id: number;
            edges: number[];
            positionId?: string;
        }[];
        side: 'left' | 'right' | 'top' | 'bottom' | 'left-top' | 'right-top';
        otherSide: 'left' | 'right' | 'top' | 'bottom' | 'left-top' | 'right-top';
        angle?: number;
        isDefaultLength?: boolean;
        shift?: number;
        profile?: Profile;
    }) {
        super(params);
        if (params) {
            this.direction = params.direction;
            this.adjacentOtherSideProfileId = params.adjacentOtherSideProfileId;
            this.profileCategoryId = params.profileCategoryId;
            this.framesId = params.framesId;
            this.otherFramesId = params.otherFramesId;
            this.otherSide = params.otherSide;
            this.angle = params.angle ?? 0;
            this.isDefaultLength = params.isDefaultLength || false;
            this.shift = params.shift || 0;
            if (this.direction === 'horizontal') {
                this.perpendicularCouplings = {
                    top: [],
                    bottom: [],
                };
            } else {
                this.perpendicularCouplings = {
                    left: [],
                    right: [],
                };
            }
            this.profile = params.profile;
        }
    }
}
